import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from '../../components/feature/HeroSection';
import TrustBar from '../../components/feature/TrustBar';
import ServicesGrid from '../../components/feature/ServicesGrid';
import AIAnswerBlock from '../../components/feature/AIAnswerBlock';
import ProcessSection from '../../components/feature/ProcessSection';
import CTABand from '../../components/feature/CTABand';
import WhyChooseUs from '../../components/feature/WhyChooseUs';
import ServiceAreas from '../../components/feature/ServiceAreas';
import TestimonialsSection from '../../components/feature/TestimonialsSection';
import FAQSection from '../../components/feature/FAQSection';
import FinalCTA from '../../components/feature/FinalCTA';

const SERVICES = [
  {
    icon: 'ri-draft-line',
    title: 'Photometric Lighting Design',
    description:
      'Signed and sealed photometric plans for new construction and commercial site upgrades. Computer-modeled foot-candle layouts meeting permit requirements for parking lots, retail centers, sports courts, and all commercial applications.',
    link: '/location',
  },
  {
    icon: 'ri-car-line',
    title: 'Dealership & Retail Site Lighting',
    description:
      'High-performance LED fixtures for auto dealerships, shopping centers, and retail plazas. Maximize vehicle visibility and property curb appeal while dramatically reducing nightly energy overhead across large commercial footprints.',
    link: '/location',
  },
  {
    icon: 'ri-basketball-line',
    title: 'Sports & Court Lighting',
    description:
      'Commercial LED court lighting for tennis, pickleball, and multi-sport facilities. Dramatically brighter than traditional metal halide — delivering 70%+ energy reduction and significantly reduced maintenance requirements.',
    link: '/location',
  },
  {
    icon: 'ri-sun-line',
    title: 'Solar All-In-One Systems',
    description:
      'Wire-free solar LED fixtures requiring no trenching or electrical installation. Self-contained units for parking lots, pathways, and remote commercial areas. Fully functional with zero underground electrical work required.',
    link: '/location',
  },
  {
    icon: 'ri-building-2-line',
    title: 'Industrial & High Bay Lighting',
    description:
      'Premium high bay LED fixtures for warehouses, manufacturing plants, and industrial facilities. Modular construction for superior heat dissipation, long-term reliability, and consistent output in demanding operational environments.',
    link: '/location',
  },
  {
    icon: 'ri-seedling-line',
    title: 'Agricultural & Multi-Family',
    description:
      'Specialized LED solutions for agricultural operations and multi-family residential properties. Full-service project management covering design, specification, installation coordination, and utility rebate acquisition.',
    link: '/location',
  },
];

const AI_QAS = [
  {
    question: 'What commercial lighting services does Southeast Lighting & Design offer?',
    answer:
      'We offer photometric design and signed plans, commercial LED specification, car dealership and retail site lighting, tennis and sports court lighting, solar all-in-one systems, industrial high bay fixtures, agricultural lighting, multi-family and sign lighting — serving commercial clients throughout Tampa Bay and across Florida.',
  },
  {
    question: 'What is included in a full-service commercial lighting engagement?',
    answer:
      'Our full-service approach covers photometric design and signed plans, LED product specification and sourcing, installation coordination with qualified contractors, and utility rebate acquisition. Clients receive a single point of contact managing the entire project — no need to coordinate multiple vendors or navigate rebate programs independently.',
  },
  {
    question: 'Who benefits most from professional commercial lighting services?',
    answer:
      'Any commercial property owner seeking to reduce energy costs, eliminate maintenance cycles, or improve lighting quality benefits from professional LED services. We serve auto dealerships, retail shopping centers, sports facilities, industrial warehouses, agricultural operations, RV parks, and multi-family residential properties throughout Tampa Bay.',
  },
];

const BENEFITS = [
  {
    icon: 'ri-check-double-line',
    title: 'End-to-End Project Management',
    description:
      'From photometric design and signed plans through installation coordination and rebate acquisition — we manage every phase so your team stays focused on operations, not the lighting project.',
  },
  {
    icon: 'ri-tools-line',
    title: 'Modular Commercial LED Design',
    description:
      'Our commercial LED fixtures feature modular construction for superior heat dissipation, extended operational lifespan, consistent output reliability, and simplified maintenance when field service is required.',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Utility Rebate Acquisition',
    description:
      'Utility rebate programs can significantly reduce upfront project investment. We manage the entire rebate application process on your behalf to capture every available incentive from your provider.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Long-Term Performance Standards',
    description:
      'Commercial LED products are specified for top-tier performance and longevity — eliminating the frequent bulb replacements and ballast failures that drive maintenance costs in traditional commercial lighting systems.',
  },
];

const PROJECTS = [
  {
    image: 'https://www.selightingdesign.com/wp-content/uploads/2022/02/VPC-Pic-9-scaled-2048x1000.jpg',
    imageAlt: 'VPC commercial site lighting project by Southeast Lighting & Design, Florida',
    name: 'VPC Commercial Project',
    location: 'Florida',
    type: 'Commercial Site Lighting',
    metric: '70%+',
    metricLabel: 'Energy Reduction',
  },
  {
    image: 'https://www.selightingdesign.com/wp-content/uploads/2019/02/Crown-Acura-2-2048x1000.jpg',
    imageAlt: 'LED site lighting upgrade at Crown Acura dealership in Clearwater, Florida',
    name: 'Crown Acura',
    location: 'Clearwater, Florida',
    type: 'Auto Dealership Lighting',
    metric: 'LED',
    metricLabel: 'Complete Upgrade',
  },
  {
    image: 'https://www.selightingdesign.com/wp-content/uploads/2019/02/Alafaya-Square-1-2048x1000.jpg',
    imageAlt: 'LED site lighting at Alafaya Square retail center in Oviedo, Florida',
    name: 'Alafaya Square',
    location: 'Oviedo, Florida',
    type: 'Retail Site Lighting',
    metric: '70%+',
    metricLabel: 'Energy Saved',
  },
  {
    image: 'https://www.selightingdesign.com/wp-content/uploads/2019/01/Safety-Harbor-Tennis-Court-2048x1000.jpg',
    imageAlt: 'LED sports lighting at Safety Harbor Tennis Courts in Safety Harbor, Florida',
    name: 'Safety Harbor Tennis Courts',
    location: 'Safety Harbor, Florida',
    type: 'Sports Court Lighting',
    metric: 'Signed',
    metricLabel: 'Photometric Plan',
  },
];

const AREA_GROUPS = [
  {
    region: 'Pinellas County',
    cities: ['Clearwater', 'St. Petersburg', 'Safety Harbor', 'Dunedin', 'Tarpon Springs', 'Largo'],
  },
  {
    region: 'Hillsborough County',
    cities: ['Tampa', 'Brandon', 'Plant City', 'Lutz', 'Temple Terrace', 'Riverview'],
  },
  {
    region: 'Pasco County',
    cities: ['New Port Richey', 'Land O\' Lakes', 'Wesley Chapel', 'Zephyrhills', 'Dade City'],
  },
  {
    region: 'Central Florida & Beyond',
    cities: ['Oviedo', 'Orlando', 'Seminole County', 'Winter Haven', 'Lake Wales', 'Nationwide'],
  },
];

const FAQ_ITEMS = [
  {
    question: 'What does photometric lighting design include?',
    answer:
      'Photometric design includes a computer-modeled lighting layout calculating foot-candle levels across your entire property. We produce signed and sealed plans showing fixture placement, pole mounting heights, and light distribution patterns — ready for building permit submission and engineer review at any Florida jurisdiction.',
  },
  {
    question: 'How much does commercial LED lighting cost in Tampa Bay?',
    answer:
      'Project costs vary based on property size, fixture quantity, application type, and whether photometric design or new poles are required. Most commercial projects achieve full ROI within two to five years through energy savings. Florida utility rebates can further offset upfront investment. We provide complimentary assessments before any commitment.',
  },
  {
    question: 'Do you offer Solar All-In-One LED lighting in Tampa Bay?',
    answer:
      'Yes. We offer Solar All-In-One LED fixtures that require no wiring or electrical installation — fully self-contained with integrated solar panel and battery storage. These are ideal for Tampa Bay commercial parking lots, pathways, and remote property areas where the cost of electrical trenching would be a significant project expense.',
  },
  {
    question: 'Why is commercial LED better than traditional HID or metal halide lighting?',
    answer:
      'Commercial LED consumes 70%+ less energy than HID or metal halide systems, requires far less maintenance due to 50,000–100,000 hour rated lifespans, produces superior light quality and color rendering, and delivers strong financial returns through dramatically lower energy costs and eliminated maintenance cycles over time.',
  },
  {
    question: 'Do you coordinate installation or just supply LED equipment?',
    answer:
      'We provide full-service coordination — not equipment supply alone. We manage the complete project from photometric design and product specification through installation coordination with licensed contractors and utility rebate acquisition. Our clients have a single expert point of contact responsible for every phase of the commercial lighting upgrade.',
  },
  {
    question: 'What types of sports and court lighting do you provide?',
    answer:
      'We provide LED lighting for tennis courts, pickleball courts, multi-use sports facilities, and recreational parks throughout Tampa Bay and Florida. Our sports lighting designs meet precise foot-candle standards for competitive play while reducing power consumption by more than 70% compared to traditional metal halide court lighting systems.',
  },
];

export default function ServicesPage() {
  return (
    <div className="bg-off-white">
      <Navbar />
      <HeroSection
        eyebrow="Commercial & Industrial Lighting Services — Tampa Bay, FL"
        headline="Expert LED Lighting Services for Every Commercial Application."
        subheadline="From photometric design and product specification to installation coordination and rebate acquisition — Southeast Lighting & Design delivers the complete service suite for commercial projects of every scale."
        ctaText="Request a Free Consultation"
        ctaLink="/location"
        secondaryCta="Call 727-914-9002"
        secondaryCtaLink="tel:7279149002"
        bgImage="https://public.readdy.ai/ai/img_res/8f917e82bb53ceac284a785c26c8b847.jpg"
      />
      <TrustBar />
      <ServicesGrid
        eyebrow="Our Services"
        title="Full-Spectrum Commercial Lighting Solutions"
        subtitle="Premium LED services covering every commercial and industrial application across Tampa Bay and throughout Florida — managed from design to completion."
        items={SERVICES}
        ctaText="Get a Free Assessment"
        ctaLink="/location"
      />
      <AIAnswerBlock
        eyebrow="Service Information"
        title="Everything You Need to Know About Our Services"
        qas={AI_QAS}
        image="https://www.selightingdesign.com/wp-content/uploads/2019/02/Crown-Acura-2-2048x1000.jpg"
        imageAlt="LED site lighting at Crown Acura dealership in Clearwater, Florida"
      />
      <ProcessSection />
      <CTABand
        text="Our process delivers precision results with minimal burden on your operations team."
        buttonText="Get a Free Consultation"
        buttonLink="/location"
        showPhone
        variant="gold"
      />
      <WhyChooseUs
        eyebrow="Why Choose Southeast Lighting"
        headline="Full-Service Management. Superior Results."
        image="https://readdy.ai/api/search-image?query=nighttime%20exterior%20of%20premium%20car%20dealership%20lot%20with%20brilliant%20LED%20site%20lighting%20on%20tall%20poles%20illuminating%20rows%20of%20vehicles%2C%20dark%20clear%20night%20sky%2C%20warm%20white%20light%20flooding%20the%20lot%2C%20dramatic%20commercial%20photography%2C%20high%20contrast%20between%20dark%20background%20and%20bright%20LED%20illuminated%20vehicles&width=1200&height=800&seq=services-why-2026-v1&orientation=landscape"
        imageAlt="Commercial LED site lighting — auto dealership, Clearwater Florida"
        benefits={BENEFITS}
        ctaText="Get a Free Assessment"
        ctaLink="/location"
      />
      <ServiceAreas
        title="Serving Tampa Bay & Throughout Florida"
        subtitle="Commercial lighting services throughout Tampa Bay and across Florida. Nationwide project experience available."
        areaGroups={AREA_GROUPS}
      />
      <TestimonialsSection
        eyebrow="Featured Projects"
        title="Commercial Lighting Work Across Florida"
        projects={PROJECTS}
        ctaText="Request a Quote"
        ctaLink="/location"
      />
      <CTABand
        text="See what a full-service commercial lighting upgrade looks like for your property."
        buttonText="Request a Project Quote"
        buttonLink="/location"
        showPhone
        variant="dark"
      />
      <FAQSection
        title="Commercial Lighting Service FAQs"
        items={FAQ_ITEMS}
        image="https://www.selightingdesign.com/wp-content/uploads/2021/03/Canopy-Oaks-6-2048x1000.jpg"
        imageAlt="Solar All-In-One LED lighting at Canopy Oaks RV Resort — Southeast Lighting & Design"
      />
      <FinalCTA
        eyebrow="Start Your Project Today"
        headline="Ready for Expert Commercial Lighting Services?"
        subtext="Tell us about your property and lighting goals. We'll provide a complimentary assessment and a detailed project proposal — at no obligation to you."
      />
      <Footer />
    </div>
  );
}
